import React, { ReactNode } from "react";
import { Typography, Dialog, DialogTitle, DialogContent, IconButton } from "@material-ui/core";
import CloseIcon from "@material-ui/icons/Close";
import { makeStyles } from "@material-ui/core/styles";

const useStyles = makeStyles((theme) => ({
    dialogRoot: {
        "& .MuiDialog-paperWidthFalse": {
            width: "calc(100% - 2*50px)"   
        },

        "& .MuiDialog-paperScrollPaper":  {
            height: "calc(100% - 2*50px)"
        }
    },
    dialogTitle: {
        margin: 0,
        padding: theme.spacing(2),
    },
    iconButton: {
        position: "absolute",
        top: -10,
        right: 0,
        color: "white"
    },
    closeButton: {
        position: "absolute",
        right: theme.spacing(1),
        top: theme.spacing(1),
        color: "black"
    },
    content: {
        textAlign: "center"
    }
}));

type PopupWindowProps = {
    open: boolean,
    dialogTitle: string,
    onCloseDialog: () => void,
    childrenNode: ReactNode   
}

/**
 *   The Component is re-usable component, provide a basic pop up window with close button
 */
const PopupWindow: React.FunctionComponent<PopupWindowProps>= (props: PopupWindowProps) => {
    const styles = useStyles();

    const handleClose = () => {
        props.onCloseDialog();
    }
    
    return (
        <Dialog className={styles.dialogRoot} maxWidth={false} onClose={handleClose} open={props.open}>
            <DialogTitle className={styles.dialogTitle}>
                <Typography variant="h6">{props.dialogTitle}</Typography>
                <IconButton className={styles.closeButton} onClick={handleClose}>
                    <CloseIcon />
                </IconButton>
            </DialogTitle>
            <DialogContent className={styles.content} dividers>
                {props.childrenNode}
            </DialogContent>
        </Dialog>
    );
}

export default PopupWindow;